import { Serializable } from '@/models/core/serializable';

export class Destination implements Serializable<Destination> {
  ID: number; // 行き先ID
  destinationName: string = ''; // 行き先名称

  deserialize(input: any): Destination {
    this.ID = input.ID;
    this.destinationName = input.destinationName;
    return this;
  }
}
